import { FormProductOptionValue } from '@common/models/Option';
import { getProductStoreLink, PRODUCT_CUSTOM_FIELD_TYPE } from '@common/models/Product';
import { CartProductType } from '@common/store/cart/slice';
import {
  addProductToCart,
  removeProductFromCart,
  setProductQuantityInCart,
  subtractProductFromCart,
} from '@common/store/cart/slice';
import { WishListSliceType } from '@common/store/wishlist/slice';
import Rupee from '@components/Rupee';
// import Stepper from '@components/Stepper';
import DeleteIcon from '@images/CartDelete.svg';
import Arrow from '@images/variantDownArrow.svg';
import Rupees, { rupees } from '@instamojo/rupee';
import Image from '@lib/Image';
import OutsideClickHandler from '@lib/OutsideClickHandler';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

interface CartItemProps {
  index?: number;
  product: CartProductType;
  addProductToCart: typeof addProductToCart;
  subtractProductFromCart: typeof subtractProductFromCart;
  removeProductFromCart: typeof removeProductFromCart;
  cartProductQuantity: number;
  cartHasOptionProduct: boolean;
  cartHasVariant: boolean;
  alterCoupon?: () => void;
  removeProductFromBundle: ({ product: CartProductType, isRemoveProduct: boolean }) => void;
  addUserWishList?: (product: CartProductType) => void;
  removeUserWishList?: (product: CartProductType) => void;
  wishlist: WishListSliceType;
  setProductQuantityInCart: typeof setProductQuantityInCart;
}

const CartItem: React.FC<CartItemProps> = ({
  index,
  product,
  // addProductToCart,
  // subtractProductFromCart,
  removeProductFromCart,
  // cartProductQuantity,
  cartHasVariant,
  alterCoupon,
  removeProductFromBundle,
  addUserWishList,
  setProductQuantityInCart,
  // removeUserWishList,
  wishlist,
}) => {
  const { wishListProducts } = wishlist;
  const [isProductInWishlist, setisProductInWishlist] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    getWishList(product);
  }, [product, wishListProducts]);

  const getWishList = (product) => {
    const isFound = wishListProducts?.results?.find((wishListProduct) => {
      return wishListProduct?.id === product?.id;
    });
    if (isFound) setisProductInWishlist(true);
    else return setisProductInWishlist(false);
  };

  const removeProduct = () => {
    product.bundleId ? removeProductFromBundle({ product, isRemoveProduct: true }) : removeProductFromCart({ product });
  };

  const onWishListClickHandler = () => {
    if (isProductInWishlist) {
      removeProduct();
    } else {
      addUserWishList(product);
      removeProduct();
    }
    setisProductInWishlist(!isProductInWishlist);
  };

  const optionValues = (option) => {
    return (
      <div className="text-14 text-subTextColor flex font-medium justify-center items-center">
        {option?.field_type === PRODUCT_CUSTOM_FIELD_TYPE.TEXT ||
        option?.field_type === PRODUCT_CUSTOM_FIELD_TYPE.DATE ||
        option?.field_type === PRODUCT_CUSTOM_FIELD_TYPE.DATETIME ? (
          <div>{option?.values[0]}</div>
        ) : option?.field_type === PRODUCT_CUSTOM_FIELD_TYPE.FILE ? (
          <div>
            <a
              href={option.public_urls[option.values[0]] as string}
              target="_blank"
              rel="noreferrer"
              download={option.public_urls[option.values[0]]}
              className="text-textColor"
            >
              File Uploaded
            </a>
          </div>
        ) : option?.field_type === PRODUCT_CUSTOM_FIELD_TYPE.RADIO ? (
          <div>{(option?.values as FormProductOptionValue).join(', ')}</div>
        ) : option?.field_type === PRODUCT_CUSTOM_FIELD_TYPE.CHECKBOX ? (
          <div>
            <div>{(option.values as FormProductOptionValue[]).map((v) => v).join('|')}</div>
          </div>
        ) : option.field_type === PRODUCT_CUSTOM_FIELD_TYPE.MULTI_FILE ? (
          <div>
            {(option?.values as FormProductOptionValue[]).map((v, index) => {
              return (
                <div key={index}>
                  <a
                    href={option?.public_urls[v] as string}
                    target="_blank"
                    rel="noreferrer"
                    download={option?.public_urls[v]}
                    className="text-textColor"
                  >
                    File Uploaded {index + 1}
                  </a>
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    );
  };
  return (
    <div key={product.id} className="w-full py-22 rounded-lg px-20 mb-20 border-slideBorder border">
      <div className="flex flex-col md:flex-row">
        <div className="flex flex-wrap md:flex-nowrap">
          <div className="flex w-full justify-between">
            <Link to={getProductStoreLink(product)} className="block h-120 w-120 rounded-4 mr-20 overflow-hidden">
              <img
                className="object-contain h-120 w-120 rounded-4 border border-slideBorder"
                src={product.images[0]}
                alt={product.title}
              />
            </Link>
            <div className="md:hidden flex flex-col items-end">
              <div className="w-full justify-end flex">
                <div
                  font-customisation="para-text"
                  className="h-28 w-28 bg-footer-bg flex items-center justify-center rounded-3"
                  color-customisation="page-body-text"
                  id={'cart-item-delete-' + (index + 1)}
                >
                  <img
                    src={DeleteIcon}
                    alt="delete"
                    onClick={() => {
                      removeProduct();
                      alterCoupon();
                    }}
                    className="cursor-pointer"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex mt-16 md:mt-0 w-full items-start relative">
          <div className="flex flex-col h-full w-full md:flex-row md:justify-between">
            <div className="w-fit flex justify-between flex-col h-full md:w-360 mr-0 md:mr-16">
              <div className="flex flex-col">
                <Link to={getProductStoreLink(product)} className="flex flex-wrap">
                  <span
                    className="text-16 font-bold text-textColor"
                    font-customisation="section-heading"
                    color-customisation="page-heading"
                  >
                    {product.title}
                  </span>
                </Link>

                <div>
                  {cartHasVariant ? (
                    <div className="flex-wrap mt-10 flex">
                      {product?.optionValues?.map((item, index) => {
                        return (
                          <div
                            className=" flex items-center text-textColor font-medium text-14 leading-21 mr-15 border-r-2 border-cartBorder last:border-0"
                            key={item + index}
                            font-customisation="para-text"
                            color-customisation="page-body-text"
                          >
                            <p className="flex mr-15">{item}</p>
                          </div>
                        );
                      })}
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="">
                {product?.formProductOptions || product?.formCustomFields ? (
                  <div className="mt-12 md:mt-2">
                    <div className="text-textColor cursor-pointer text-14 font-medium">
                      <OutsideClickHandler onOutsideClick={() => setIsDropdownOpen(false)}>
                        <div className="relative">
                          <div className="flex items-center gap-4">
                            More Information
                            <img
                              className={classnames('w-12 mt-2 h-12 ml-2 object-contain ', {
                                'transform rotate-180': isDropdownOpen,
                              })}
                              src={Arrow}
                              alt="Down"
                              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                            />
                          </div>

                          {isDropdownOpen ? (
                            <div className="flex p-16 left-0  mt-10 min-w-270 max-w-full flex-col absolute bg-white shadow-cart rounded-4 z-40">
                              <div className="flex flex-wrap flex-col gap-12">
                                {product?.formProductOptions?.map((option) => {
                                  return (
                                    <div
                                      key={option.option.id}
                                      className="flex items-center"
                                      font-customisation="para-text"
                                      color-customisation="page-body-text"
                                    >
                                      <span className="flex flex-col items-center">
                                        <span className="text-14 font-bold text-textColor leading-21">
                                          {option.option.name}
                                        </span>
                                        <span className="text-14 font-medium text-subTextColor">
                                          {optionValues(option)}
                                        </span>
                                      </span>
                                    </div>
                                  );
                                })}
                                {product?.formCustomFields?.map((option) => {
                                  return (
                                    <div
                                      key={option?.id}
                                      className="flex items-center"
                                      font-customisation="para-text"
                                      color-customisation="page-body-text"
                                    >
                                      <span className="flex flex-col items-start">
                                        <span className="text-14 font-bold text-textColor leading-21">
                                          {option?.title}
                                        </span>
                                        <span className="text-14 font-medium text-subTextColor">
                                          {optionValues(option)}
                                        </span>
                                      </span>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </OutsideClickHandler>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>

            <div className="hidden md:flex items-start" font-customisation="para-text">
              {QuantityOptionsBar(product.cartQuantity, setProductQuantityInCart, product)}
            </div>
            <div
              className="flex flex-col md:w-220 mt-10 md:mt-0 flex-wrap text-left md:text-right"
              font-customisation="para-text"
            >
              <div className="flex justify-start md:justify-end items-center">
                <div
                  className="text-18 text-textColor leading-21 font-medium flex"
                  color-customisation="page-body-text"
                >
                  <Rupee value={product.cartQuantity * product.finalPrice} defaultClass={true} />
                </div>
                {product.price > product.finalPrice && (
                  <div className="text-textColor text-opacity-50 leading-22 line-through text-14 ml-4 font-medium h-20">
                    <Rupee value={product.cartQuantity * product.price} defaultClass={true} />
                  </div>
                )}
              </div>
              {product?.savings && product.price > product.finalPrice && (
                <div className="flex items-center justify-start md:justify-end my-2">
                  <span className="text-14 font-medium text-success">
                    You save <Rupees className="" /> {rupees(product.savings.amount * product.cartQuantity, false)}
                    <span className="mx-4 text-success">&#8226;</span>
                    {product.savings.percentage}% OFF
                  </span>
                </div>
              )}
            </div>
            <div className="flex md:hidden mt-10 md:mt-0 items-start" font-customisation="para-text">
              {QuantityOptionsBar(product.cartQuantity, setProductQuantityInCart, product)}
              <div className="flex md:hidden self-end pb-4 md:pb-0">
                <div className="items-end flex">
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      onWishListClickHandler();
                    }}
                    className="cursor-pointer min-w-150 justify-end flex font-medium text-14 leading-14 text-theme"
                    font-customisation="para-text"
                    color-customisation="page-body-text"
                  >
                    Move To Wishlist
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="hidden md:flex md:flex-1 h-full self-end pb-4 md:pb-0">
            <div className="w-full justify-between items-end flex flex-col h-full">
              <div
                font-customisation="para-text"
                className="h-28 w-28 hidden bg-footer-bg md:flex items-center justify-center rounded-3"
                color-customisation="page-body-text"
                id={'cart-item-delete-' + (index + 1)}
              >
                <img
                  src={DeleteIcon}
                  alt="delete"
                  onClick={() => {
                    removeProduct();
                    alterCoupon();
                  }}
                  className="cursor-pointer"
                />
              </div>
              <div
                onClick={(e) => {
                  e.preventDefault();
                  onWishListClickHandler();
                }}
                className="cursor-pointer min-w-150 justify-end flex font-medium text-14 leading-14 text-theme"
                font-customisation="para-text"
                color-customisation="page-body-text"
              >
                Move To Wishlist
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const QuantityOptionsBar = (quantity, setProductQuantityInCart, product) => {
  //cartProductQuantity, quickView
  const range = (start, end, step) => {
    return Array.from(Array.from(Array(Math.ceil((end - start) / step)).keys()), (x) => start + x * step);
  };
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  return (
    <div className="flex items-center cursor-pointer w-full md:w-auto">
      <div className={classnames('flex gap-8 md:gap-20 w-full', {})}>
        <div
          className={classnames(
            'text-subTextColor text-opacity-50 font-medium text-14 leading-21 flex items-center',
            {},
          )}
          color-customisation="page-body-text"
        >
          Qty
        </div>
        <div className="flex justify-start items-center ">
          <div
            tabIndex={0}
            onBlur={(e) => {
              e.preventDefault();
              setIsDropdownOpen(false);
            }}
            className="focus:outline-none"
          >
            <div className="flex flex-col">
              <div className="flex items-center">
                <div
                  id="quantity-dropdown"
                  className={classnames(
                    'flex justify-between cursor-pointer pl-10 items-center rounded-3 flex-wrap focus:outline-none focus:h-200 border border-variant-border',
                    {
                      'w-70 min-w-70 h-32': true,
                    },
                  )}
                  onClick={(e) => {
                    e.preventDefault();
                    isDropdownOpen ? setIsDropdownOpen(false) : setIsDropdownOpen(true);
                  }}
                >
                  <span
                    className="leading-21 ml-4 text-14 font-medium"
                    font-customisation="para-text"
                    color-customisation="page-body-text"
                  >
                    {quantity === -1 ? 'Choose Quantity' : quantity}
                  </span>
                  <div className="cursor-pointer mr-16">
                    <Image
                      className={'w-12 h-12 object-contain rounded bg-white'}
                      src={Arrow}
                      noDefaultDimensions
                      alt="Down"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="">
              {isDropdownOpen && (
                <div
                  className={classnames(
                    'flex cursor-pointer absolute flex-col mt-4 border overflow-y-scroll border-variant-border bg-white z-40 rounded-5',
                    {
                      'w-70 min-w-70 max-h-100': true,
                    },
                  )}
                  onMouseLeave={(e) => {
                    e.preventDefault();
                    setIsDropdownOpen(false);
                  }}
                  onBlur={(e) => {
                    e.preventDefault();
                    // setIsHover(null);
                  }}
                  font-customisation="para-text"
                >
                  {range(product.minQuantity, product.maxQuantity + 1, 1).map((optionValue) => (
                    <div
                      className="flex hover:bg-theme hover:bg-opacity-10 text-subTextColor text-16 leading-22 font-medium pl-10 min-h-32 items-center"
                      key={optionValue}
                      onClick={() => {
                        console.log(product, optionValue);
                        setProductQuantityInCart({ product: product, quantity: optionValue });
                        setIsDropdownOpen(false);
                      }}
                      font-customisation="para-text"
                      color-customisation="page-body-text"
                    >
                      {optionValue}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItem;
